import { render } from "./Customer.vue?vue&type=template&id=0a454ae6&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=0a454ae6&lang=stylus&scoped=true"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a454ae6"]])

export default __exports__